import { useState, useEffect, useCallback } from "react";
import { apiService } from "../services/apiService";

export interface UserItem {
  id: string;
  name: string;
  email: string;
  trialStartedAt: string;
  trialEndDate: string;
  activationDate: string | null;
  status: "Active" | "Inactive";
}

export const useUsers = () => {
  const [users, setUsers] = useState<UserItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
console.log('@@@@@@@ -- users',users)
  const fetchUsers = useCallback(async () => {
    try {
      setLoading(true);
      setError("");
      const data = await apiService.get<{ success: boolean; users: UserItem[]; message?: string }>(
        "portal-api/users"
      );
      if (data.success) {
        setUsers(data.users);
      } else {
        setError(data.message || "Failed to load users.");
      }
    } catch (err: any) {
      console.error("Fetch users error:", err);
      setError(err.message || "Network error. Please make sure the backend is running.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return { users, setUsers, loading, error, refetch: fetchUsers };
};
